module.exports = __webpack_public_path__ + "img/ic_24_whitelabel_support.eb46aff4.svg";